// Shared types for Tender Assistant components

export type MatchConfidence = 'verified' | 'high' | 'medium' | 'low' | 'none';

export type ProductMatch = {
    product_id: string;
    confidence?: MatchConfidence;
};

export type TenderRequirement = {
    page_index: number;
    hierarchical_reference_number?: string;
    product_reference?: {
        product_name?: string;
        danfoss_product_type?: {
            type?: string;
            explicit: boolean;
            confidence: 'high' | 'medium' | 'low';
        };
        product_code_number?: string;
    };
    product_specifications?: Array<{
        attribute_type: string;
        attribute_value: string;
    }>;
    number_of_units?: number;
    unit_of_measurement?: string;
    additional_info?: string;
    product_matches: ProductMatch[];
};

export type TenderRequirementInput = {
    id: string;
    page_index?: number;
    hierarchical_reference_number?: string;
    product_reference?: string;
    product_type?: string;
    number_of_units?: number;
    product_id: string;
    feedback?: string;
    original_requirement_index?: number;
    unit_of_measurement?: string;
    manual: boolean;
    active: boolean;
    hide?: boolean;
    done?: boolean;
    vote?: 1 | -1;
};

// Streaming-specific types
export interface StreamedRequirement {
    requirement: TenderRequirement;
    index: number;
}

export interface ExtractionComplete {
    total_extracted: number;
}

export interface StreamingComplete {
    artifact_id: string;
    total_requirements: number;
}

// Confidence indicators
export const confidenceIndicators: { [key in MatchConfidence]: string } = {
    "verified": "✅",
    "high": "🟢",
    "medium": "🟡",
    "low": "🔴",
    "none": "❓",
};